import React, { useMemo } from 'react';
import { useFragment } from 'react-relay/hooks';

import { graphql } from 'babel-plugin-relay/macro';
import { Typography, TypographyProps } from 'embeds/components';
import { get } from 'lodash';
import moment from 'moment';

import { TypographyChatActivityUpdatedAt_EmbedChatActivity$key } from './__generated__/TypographyChatActivityUpdatedAt_EmbedChatActivity.graphql';

export interface TypographyChatActivityUpdatedAtProps extends Omit<TypographyProps, 'classes' | 'children'> {
  fragmentRef: TypographyChatActivityUpdatedAt_EmbedChatActivity$key;
}

const TypographyChatActivityUpdatedAt: React.FC<TypographyChatActivityUpdatedAtProps> = ({ fragmentRef, ...rest }) => {
  const chatActivity = useFragment<TypographyChatActivityUpdatedAt_EmbedChatActivity$key>(
    graphql`
      fragment TypographyChatActivityUpdatedAt_EmbedChatActivity on ChatActivity {
        updatedAt
      }
    `,
    fragmentRef,
  );

  const updatedAt = useMemo(() => {
    const value = get(chatActivity, 'updatedAt') as string;
    if (moment().diff(value, 'days') > 7) {
      return moment(value).format('ll');
    }
    let date = moment(value);
    if (date.isAfter()) {
      date = moment();
    }
    return date
      .fromNow()
      .replace(/ hours/, 'h')
      .replace(/ minutes/, 'm')
      .replace(/ days/, 'd');
  }, [chatActivity]);

  return <Typography {...rest}>{updatedAt}</Typography>;
};

export default TypographyChatActivityUpdatedAt;
